"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const myFlightsHelper_1 = require("../../../services/myFlightsHelper");
const FlightDetailsHeader = ({ flightData }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-26-600", children: (0, myFlightsHelper_1.getCityToCityText)(flightData) }), (0, jsx_runtime_1.jsx)("p", { className: "subtitle", children: flightData.departureDateFormatted })] }));
exports.default = FlightDetailsHeader;
